import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/es-us'
import 'dayjs/locale/te'

import { SupportedLocaleEnum } from '@vetahealth/tuna-can-api'
import { Locale } from 'antd/es/locale'
import antEnUS from 'antd/lib/locale/en_US'
import antEsES from 'antd/lib/locale/es_ES'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { storage } from '../storage'
import { antTeIn } from './antLocales/telugu/antTeIn'
import enUS from './en-US.json'
import es419 from './es-419.json'
import teIN from './te-IN.json'

enum FallbackLocale {
  EN = 'en',
  ES = 'es',
  TE = 'te',
}

export const antLocales: Record<string, Locale> = {
  en: antEnUS,
  es: antEsES,
  te: antTeIn,
}

export function initI18n(): void {
  i18next.use(initReactI18next).init({
    fallbackLng: 'en',
    react: {
      useSuspense: false,
    },
    resources: {
      en: { translation: enUS },
      es: { translation: es419 },
      te: { translation: teIN },
    },
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: false,
    returnNull: false,
  })
}

export function getInitialLocale(): SupportedLocaleEnum {
  const supportedLocales = Object.values(SupportedLocaleEnum)

  const storedLocale = storage.getLocale()

  let systemLocale: SupportedLocaleEnum | undefined
  for (const locale of navigator.languages as SupportedLocaleEnum[]) {
    if (systemLocale) break

    systemLocale = supportedLocales.includes(locale)
      ? locale
      : supportedLocales.find((supportedLocale) => supportedLocale.startsWith(locale))
  }

  return storedLocale || systemLocale || SupportedLocaleEnum.EnUs
}

export function getLibLocale({
  lib,
  locale = SupportedLocaleEnum.EnUs,
}: {
  lib: 'ant' | 'dayjs'
  locale?: SupportedLocaleEnum
}): FallbackLocale | SupportedLocaleEnum {
  const libLocales: Array<FallbackLocale | SupportedLocaleEnum> = {
    ant: [FallbackLocale.EN, FallbackLocale.ES, FallbackLocale.TE],
    dayjs: [FallbackLocale.EN, FallbackLocale.ES, SupportedLocaleEnum.EnUs, FallbackLocale.TE],
  }[lib]

  return libLocales.find((libLocale) => [locale, locale.slice(0, 2)].includes(libLocale)) || libLocales[0]
}
